<template>
	<div
		class="application-widget"
		:effects="effects"
		:tabindex="tabindex"
		@click="handleClick($event)"
	>
		<div class="application-widget-header flex-gap-8">
			<!--@slot Used for Header Data -->
			<slot name="application-header" />
		</div>
		<div
			v-if="$slots['application-body']"
			class="application-widget-body"
			:class="hoverEffect ? 'add-hover' : ''"
		>
			<!-- @slot Used for Stats Data -->
			<slot name="application-body" />
		</div>

		<div class="application-widget-footer">
			<!--@slot Used for Footer Data -->
			<slot name="application-footer" />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "ApplicationWidget",
	props: {
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		hoverEffect: {
			type: Boolean,
			default: false
		},
		effects: {
			type: Boolean,
			default: false
		}
		/**
		 * defualt | 'success' | 'error' | 'warning' | 'inProgress'
		 *  */
		// type: {
		// 	type: String,
		// 	default: "default",
		// 	validator: function (value) {
		// 		return ["default", "success", "error", "warning", "inProgress"].includes(value);
		// 	}
		// }
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
$types: (
	"default": var(--dashboard-element-light),
	"success": var(--dashboard-success),
	"error": var(--dashboard-danger),
	"warning": var(--dashboard-warning),
	"inProgress": var(--dashboard-primary)
);

.slide-top-wrap-aw {
	padding: 24px 24px 0 24px;
}

.app-widget-outer-wrap {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
	grid-gap: 8px;

	&.slide {
		padding: 24px;
		grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));

		div.application-widget > div.application-widget-footer > * {
			padding: 12px 16px;
		}
	}

	// @media (min-width: 1300px) {
	// 	grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
	// }
}

.slideout-application-info-wrap {
	.disabled-effect {
		opacity: 0.3 !important;
	}
	.aw-meta-lable {
		flex: 0 0 150px;
	}
}

div.application-widget {
	position: relative;
	overflow: hidden;
	width: 100%;
	min-width: 350px;
	// max-width: 450px;
	// cursor: pointer;
	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-element-light);
	border-radius: 4px;
	position: relative;

	// @each $type, $color in $types {
	// 	&[type="#{$type}"] {
	// 		&:not([type="default"]) {
	// 			&:before {
	// 				content: "";
	// 				width: 100%;
	// 				height: 8px;
	// 				position: absolute;
	// 				display: block;
	// 				background: $color;
	// 				border-radius: 4px 4px 0 0;
	// 			}
	// 		}
	// 	}
	// }
	.flow-loader {
		padding: 0;
		flex: 0;
	}
	> div.application-widget-header {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border-light);
		display: flex;
		justify-content: space-between;
	}
	.aw-wrap-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&.w-225 {
			max-width: 225px;
		}
		&.w-260 {
			max-width: 260px;
		}
	}
	> div.application-widget-body {
		padding: 16px;
		border-bottom: 1px solid var(--dashboard-border-light);
		height: 116px;

		.app-w-status-wrap {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			height: 100%;
			> * {
				display: flex;
				align-items: center;
			}
		}
		&.add-hover {
			background: transparent;
			transition: background-color 0.3s linear;
			&:hover {
				cursor: pointer;
				background-color: var(--dashboard-element);
			}
		}
	}

	> div.application-widget-footer {
		padding: 0px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		> * {
			display: flex;
			align-items: center;
			padding: 16px;
			justify-content: center;
			border-right: 1px solid var(--dashboard-border-light);
			background: transparent;
			transition: background-color 0.3s linear;
			&:last-child {
				border-right: none;
			}
			&:not(.disabled):hover {
				background-color: var(--dashboard-element);
				cursor: pointer;
			}
			&.disabled {
				cursor: not-allowed;
				opacity: 0.3;
			}
		}
	}
	&[effects="true"] {
		&:active {
			filter: contrast(90%);
		}
		&:hover:not(:active) {
			filter: contrast(95%);
		}
	}

	&:focus {
		// box-shadow: 0 0 0 2px var(--dashboard-primary);
		outline: none;
	}
}
</style>
